import { LOCALE_DE, LOCALE_ES, LOCALE_FR, LOCALE_IT, LOCALE_US } from '../locales/constants';
import { type Locale } from '../locales/constants';
import { Lang } from './constants';

export const getLang = (locale: string): string => locale.split('-')[0];

export const getLocaleByLang = (lang: string): Locale | null => {
    const values: Record<string, Locale> = {
        [Lang.EN]: LOCALE_US,
        [Lang.DE]: LOCALE_DE,
        [Lang.FR]: LOCALE_FR,
        [Lang.IT]: LOCALE_IT,
        [Lang.ES]: LOCALE_ES,
    };
    return values.hasOwnProperty(lang) ? values[lang] : null;
};

export const isDefaultLang = (locale: string): boolean => getLang(locale) === 'en';
